import React from 'react';
const placeholder = () => {
  throw new Error('This function is a placeholder used when creating the AlertsManagerContext, it should be overridden');
};
const defaultAlertsManager = {
  add: placeholder,
  plugin: false,
  parentAlertsAdd: null,
  showAlertsInPlugin: false
};
export const AlertsManagerContext = /*#__PURE__*/React.createContext(defaultAlertsManager);